import React, { useState } from "react";
import "../styles/CancelOrderPage.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import CancelOrderForm from "../components/CancelOrder/CancelOrderForm";
import CancelOrderItems from "../components/CancelOrder/CancelOrderItems";
import CancelConfirmModal from "../components/CancelOrder/CancelConfirmModal";
import { useCancelOrder } from "../hooks/useCancelOrder";

const ExchangeOrderPage = () => {

  const navigate = useNavigate();
  const { orderNo } = useParams();
  const { state } = useLocation();
  const items = state?.items || [];
  const [showModal, setShowModal] = useState(false);
  const cancel = useCancelOrder(orderNo, items, navigate);
  const breadcrumbPaths = [
    { label: "Orders", to: "/accounts/orders" },
    { label: "Cancel Order" },
  ];

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        transition={Slide}
      />

      <Breadcrumbs paths={breadcrumbPaths} />

      <div className="cancel-order-container">

        <CancelOrderForm
          reason={cancel.reason}
          setReason={cancel.setReason}
          reasonList={cancel.reasonList}
          comments={cancel.comments}
          setComments={cancel.setComments}
          loading={cancel.loading}
          openModal={() => setShowModal(true)}
        />

        <CancelOrderItems items={items} />

      </div>

      <CancelConfirmModal
        show={showModal}
        close={() => setShowModal(false)}
        confirm={cancel.submitCancel}
        loading={cancel.loading}
      />

      <Footer />
    </>
  );
};

export default ExchangeOrderPage;